const MyEarnings = () => {
    return(
    <>
      <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain breadscrumb-order">
                                <div style={{height: "30vh"}} className="order-box bg-theme">
                                    
                                    <div className="order-contain">
                                        <span className="text-light" style={{fontSize:"large",margin: "10vh"}}>
                                        Total Income earned
                                        <h3>₹ 10,000/-</h3>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
           
        <section className="user-dashboard-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-xxl-12 col-lg-12">  
                        <div className="dashboard-card">
                        <div className="title title-flex mt-3">
                                    <div>
                                        <h2>Income History</h2>
                                        <span className="title-leaf">
                                            <svg className="icon-width bg-gray">
                                                <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                                <div className="row g-4">
                                    <table class="table shadow">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Amount received</th>
                                                <th scope="col">Claimed via</th>
                                                <th scope="col">on Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Rs 1000</td>
                                                <td>NEFT</td>
                                                <td>02/11/2024</td>
                                            </tr>
                                            {/* {rewardCardList.length ? rewardCardList.map((item, index) => {
                                                (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.username}</td>
                                                            <td>{item.sponsor}</td>
                                                            <td>{item.joiningDate}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                                :
                                                (
                                                    <>
                                                        <tr>

                                                            <td colSpan={4} className="text-center">No data available</td>
                                                        </tr>
                                                    </>
                                                )
                                            } */}



                                        </tbody>
                                    </table>
                                </div>

                        </div>
                        </div> 
                    </div>
                </div>
        </section>
    </>)

}

export default MyEarnings;